export const invoiceFilters = (searchOrders, productMetaDataResponse) => {
  let isTrial, showInvoice;
  searchOrders.forEach((order) => {
    const { Name: orderItemName, SubscriptionBillingCycleName } =
      order?.OrderItems[0].PricingPlan;

    if (productMetaDataResponse?.Product?.PricingPlans?.length) {
      const productMetadataFilter =
        productMetaDataResponse.Product?.PricingPlans.filter(
          (item) => item.Id === order.OrderItems[0].PricingPlan.Id,
        );

      const orderProductMetadata = productMetadataFilter.length
        ? productMetadataFilter[0]
        : {};

      isTrial =
        Object.keys(orderProductMetadata).length !== 0
          ? orderProductMetadata?.AdditionalProperties?.some(
              (additionalProperty) =>
                additionalProperty.ExternalReference === 'FreeTrial' &&
                additionalProperty.Values[0].toLowerCase() === 'true',
            )
          : false;
    }

    // Invoice Filters
    const isInAppPurchase =
      orderItemName &&
      typeof orderItemName === 'string' &&
      orderItemName.toLowerCase().includes('iap');

    const isOPINorZIGGO =
      SubscriptionBillingCycleName &&
      typeof SubscriptionBillingCycleName === 'string' &&
      SubscriptionBillingCycleName.toLowerCase().includes('affiliate');

    const isRemovedType = order && order.Type === 3;

    showInvoice =
      !productMetaDataResponse || productMetaDataResponse.Fault
        ? false
        : !isTrial && !isInAppPurchase && !isOPINorZIGGO && !isRemovedType;
  });

  return showInvoice;
};
